import React, {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import ocpfLogo from '../../../../../../images/ocpfsmallicon.png';
import { PeopleOutline, Gavel, BackupTable, AttachMoney, PictureAsPdf, Support, Help } from '@mui/icons-material';
import { NavItem } from './components';

interface Props {
  pages: {
    filers: Array<PageItem>;
    legal: Array<PageItem>;
    reports: Array<PageItem>;
    data: Array<PageItem>;
    forms: Array<PageItem>;
    clerk: Array<PageItem>;
    about: Array<PageItem>;
  };
}

const SidebarNav = ({ pages }: Props): JSX.Element => {

  const theme = useTheme();

  const [activeLink, setActiveLink] = useState('');

  useEffect(() => {

    const path = window.location.pathname;
    const segments = path.split('/');
    let activeLink = '';

    if (segments.length >= 2) {
      activeLink = segments[0] + '/' + segments[1];
    } else {
      activeLink = path;
    }
    setActiveLink(activeLink);
  }, []);


  const {
    filers: filersPages,
    legal: legalPages,
    reports: reportsPages,
    data: dataPages,
    forms: formsPages,
    clerk: clerkPages,
    about: aboutPages,
  } = pages;

  return (
    <Box>
      <Box width={1} paddingX={2} paddingY={1}>
        <Box
          display={'flex'}
          component="a"
          href="/"
          width={{ xs: 100, md: 120 }}
        >
          <Box
            component={'img'}
            src={ocpfLogo}
            height={1}
            width={1}
          />
        </Box>
      </Box>
      <Box paddingX={1} paddingY={1}>
        <Box>
          <NavItem 
            title={'Filers'}
            items={filersPages}
            icon={<PeopleOutline color="primary" />} 
          />
        </Box>
        <Box>
          <NavItem 
            title={'Legal'} 
            items={legalPages} 
            icon={<Gavel color="primary" />}
            />
        </Box>
        <Box>
          <NavItem 
            title={'Reports'} 
            items={reportsPages} 
            icon={<BackupTable color="primary" />}
            />
        </Box>
        <Box>
          <NavItem 
            title={'Data'} 
            items={dataPages} 
            icon={<AttachMoney color="primary" />}
            />
        </Box>
        <Box>
          <NavItem 
            title={'Forms'} 
            items={formsPages} 
            icon={<PictureAsPdf color="primary" />}
            />
        </Box>
        <Box>
          <NavItem 
            title={'Clerks'} 
            items={clerkPages} 
            icon={<Support color="primary" />}
            />
        </Box>
        <Box>
          <NavItem 
            title={'About'} 
            items={aboutPages}
            icon={<Help color="primary" />} 
          />
        </Box>
        {/**
         * removed short version of the menu list for now
         * 
         * <MenuList>
          <MenuItem>
            <ListItemIcon>
              <PeopleOutline color="primary" />
            </ListItemIcon>
            <ListItemButton component={Link} href={'/Filers/FilerListing'}  sx={{paddingLeft:0}}>
              <ListItemText
                sx={
                  "/Filers" == activeLink
                    ? {
                        color: theme.palette.primary.main,
                      }
                    : { 
                        color: theme.palette.text.primary,
                      }
                }
              >Filers</ListItemText>
            </ListItemButton>
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <Gavel color="primary" />
            </ListItemIcon>
            <ListItemButton component={Link} href={'/Legal'} sx={{paddingLeft:0}}>
              <ListItemText
               sx={
                "/Legal" == activeLink
                  ? {
                      color: theme.palette.primary.main,
                    }
                  : { 
                      color: theme.palette.text.primary,
                    }
              }
              >Legal</ListItemText>
            </ListItemButton>
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <BackupTable color="primary" />
            </ListItemIcon>
            <ListItemButton component={Link} href={'/Reports'} sx={{paddingLeft:0}}>
              <ListItemText
               sx={
                "/Reports" == activeLink
                  ? {
                      color: theme.palette.primary.main,
                    }
                  : { 
                      color: theme.palette.text.primary,
                    }
              }
              >Reports</ListItemText>
            </ListItemButton>
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <AttachMoney color="primary" />
            </ListItemIcon>
            <ListItemButton component={Link} href={'/Data'} sx={{paddingLeft:0}}>
              <ListItemText
               sx={
                "/Data" == activeLink
                  ? {
                      color: theme.palette.primary.main,
                    }
                  : { 
                      color: theme.palette.text.primary,
                    }
              }
              >Data</ListItemText>
            </ListItemButton>
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <PictureAsPdf color="primary" />
            </ListItemIcon>
            <ListItemButton component={Link} href={'/Publications'} sx={{paddingLeft:0}}>
              <ListItemText
               sx={
                "/Publications" == activeLink
                  ? {
                      color: theme.palette.primary.main,
                    }
                  : { 
                      color: theme.palette.text.primary,
                    }
              }
              >Forms & Publications</ListItemText>
            </ListItemButton>
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <Support color="primary" />
            </ListItemIcon>
            <ListItemButton component={Link} href={'/Municipal'} sx={{paddingLeft:0}}>
              <ListItemText
               sx={
                "/Municipal" == activeLink
                  ? {
                      color: theme.palette.primary.main,
                    }
                  : { 
                      color: theme.palette.text.primary,
                    }
              }
              >Municipal Clerk</ListItemText>
            </ListItemButton>
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <Help color="primary" />
            </ListItemIcon>
            <NavItem 
              title={'About'} 
              items={aboutPages}  
              icon={<Help color="primary" />}
              />
          </MenuItem>
        </MenuList>
         * 
         * 
        */}
        
        <Box marginTop={1}>
          <Button
            size={'large'}
            variant="contained"
            color="primary"
            fullWidth
            component="a"
            target="blank"
            href="https://www.ocpfreporter.us/Account/LogOn"
          >
            Sign In
          </Button>
        </Box>
        <Box marginTop={1}>
          <Button
            size={'large'}
            variant="outlined"
            color="primary"
            fullWidth
            component="a"
            target="blank"
            href="https://www.ocpfreporter.us/OnlineOrganization/SignUp"
          >
            Register with OCPF
          </Button>
        </Box>
        <Box marginTop={1}>
          <Button
            size={'large'}
            variant="outlined"
            color="success"
            fullWidth
            component="a"
            target="blank"
            href="https://notifications.ocpf.us/"
          >
            E-Notify
          </Button>
        </Box>
         <Box marginTop={1}>
          <Button
            size={'large'}
            variant="outlined"
            color="warning"
            fullWidth
            component="a"
            target="blank"
            href="https://www.ncourt.com/x-press/X-onlinepayments.aspx?Juris=31c943a9-97cd-416f-bf50-8a0634242629"
          >
            Pay Civil Penalty
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarNav;
